import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Contact from '../components/contact';  

const ContactUs = () => {
  return (
    <div className="contact-us-page" style={{ backgroundColor: '#f1f5fc' }}>
      <Container>
        {/* Contact already includes form + map — keep a single section */}
        <Row className="mb-5">
          <Col>
            <Contact />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactUs;
